import * as React from 'react'
import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible'

// ---------------------------------------------------------------------------
// Collapsible — migrated from Radix to Base UI
// ---------------------------------------------------------------------------
// Radix: Root, CollapsibleTrigger, CollapsibleContent
// Base UI: Root, Trigger, Panel
//
// Data attribute changes:
//   Trigger: data-state="open|closed" → data-panel-open (present when open)
//   Panel:   data-state="open|closed" → data-open / data-closed
//
// onOpenChange: Radix `(open: boolean) => void`
//             → Base UI `(open: boolean, eventDetails) => void`
// We wrap to preserve the Radix-compatible single-arg signature.
// ---------------------------------------------------------------------------

function Collapsible({
  onOpenChange,
  ...props
}: Omit<React.ComponentProps<typeof CollapsiblePrimitive.Root>, 'onOpenChange'> & {
  onOpenChange?: (open: boolean) => void
}) {
  return (
    <CollapsiblePrimitive.Root
      data-slot="collapsible"
      onOpenChange={onOpenChange ? (open) => onOpenChange(open) : undefined}
      {...props}
    />
  )
}

function CollapsibleTrigger({ ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Trigger>) {
  return <CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" {...props} />
}

function CollapsibleContent({ ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Panel>) {
  return <CollapsiblePrimitive.Panel data-slot="collapsible-content" {...props} />
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
